// import React from "react";

// const DataTable = ({ columns, data, page, perPage, setPage }) => {
//   const start = (page - 1) * perPage;
//   const paginated = data.slice(start, start + perPage);

//   return (
//     <div className="overflow-x-auto">
//       <table className="min-w-full border border-gray-300 rounded-lg text-sm">
//         <thead className="bg-blue-100 text-gray-700">
//           <tr>
//             {columns.map((col, i) => (
//               <th key={i} className="p-3 border text-left">
//                 {col.header}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {paginated.length > 0 ? (
//             paginated.map((row, i) => (
//               <tr key={i} className="hover:bg-gray-50 text-center">
//                 {columns.map((col, j) => (
//                   <td key={j} className="p-3 border">
//                     {col.render ? col.render(row) : row[col.accessor]}
//                   </td>
//                 ))}
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td
//                 colSpan={columns.length}
//                 className="text-center p-4 text-gray-500"
//               >
//                 No data found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {/* Pagination Controls */}
//       <div className="flex justify-center items-center gap-3 mt-3">
//         <button
//           onClick={() => setPage((p) => Math.max(p - 1, 1))}
//           disabled={page === 1}
//           className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-40"
//         >
//           Prev
//         </button>
//         <span>
//           Page {page} of {Math.ceil(data.length / perPage) || 1}
//         </span>
//         <button
//           onClick={() =>
//             setPage((p) =>
//               start + perPage >= data.length ? p : p + 1
//             )
//           }
//           disabled={start + perPage >= data.length}
//           className="bg-gray-200 hover:bg-gray-300 px-3 py-1 rounded disabled:opacity-40"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DataTable;
// src/components/common/DataTable.jsx
import React from "react";

const DataTable = ({
  columns,
  data = [],
  page,
  totalPages = 1,
  setPage,
}) => {
  const safePage = Number(page || 1);
  const safeTotalPages = Math.max(Number(totalPages || 1), 1);
  const pageRecords = Array.isArray(data) ? data.length : 0;

  return (
    <section className="admin-data-table">
      <header className="admin-data-table-head">
        <div>
          <p className="admin-data-table-eyebrow">Records View</p>
          <h3 className="admin-data-table-title">{pageRecords} entries in current page</h3>
        </div>
        <span className="admin-data-table-page-chip">
          Page {safePage} / {safeTotalPages}
        </span>
      </header>

      <div className="admin-data-table-scroll">
        <table className="min-w-full border-collapse text-xs sm:text-sm">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="px-2 sm:px-4 py-1.5 text-left text-xs sm:text-sm font-semibold whitespace-nowrap"
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-7 text-gray-500"
                >
                  No records found
                </td>
              </tr>
            ) : (
              data.map((row, rowIdx) => (
                <tr key={rowIdx}>
                  {columns.map((col, colIdx) => (
                    <td key={colIdx} className="px-2 sm:px-4 py-1.5 text-xs sm:text-sm align-middle">
                      {col.render ? col.render(row) : row[col.accessor] ?? "-"}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {safeTotalPages > 1 && (
        <div className="admin-data-table-pagination">
          <button
            disabled={safePage === 1}
            onClick={() => setPage(safePage - 1)}
            className="admin-data-table-page-btn"
          >
            ◀ Prev
          </button>

          {Array.from({ length: safeTotalPages }).map((_, i) => {
            const pageNum = i + 1;
            return (
              <button
                key={pageNum}
                onClick={() => setPage(pageNum)}
                className={`admin-data-table-page-btn ${safePage === pageNum ? "is-active" : ""}`}
              >
                {pageNum}
              </button>
            );
          })}

          <button
            disabled={safePage === safeTotalPages}
            onClick={() => setPage(safePage + 1)}
            className="admin-data-table-page-btn"
          >
            Next ▶
          </button>
        </div>
      )}
    </section>
  );
};

export default DataTable;
